var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
export function ItemWithSelection(Component) {
    return class extends React.Component {
        render() {
            const _a = this.props, { onClick, onEnter } = _a, rest = __rest(_a, ["onClick", "onEnter"]);
            return (React.createElement("li", { onClick: onClick, onMouseOver: onEnter },
                React.createElement(Component, Object.assign({}, rest))));
        }
    };
}
//# sourceMappingURL=ItemWithSelection.js.map